import { GET, PATCH, POST } from "../../helper/xbi4RestFunctions";
export const applyLeave = async (org_id: any, org_user_id: any, data: any) => {
  const path = `/orgs/${org_id}/users/${org_user_id}/leaves`;
  return await POST(path, data)
    .then((result) => {
      console.log("...", result[0]);
      return result;
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
